<template>
<div :ref="loadingobj">    
    <div class="TTL-el-form-search-regular">
        <span class="TTL-title">新增商品</span>
        <div class="TTL-button TTL-btn-option">
        <el-badge :value="goodslist.length > 1 ? goodslist.length : ''" class="item">
        <wcbutton :option="{title:'提交数据'}" @finish="submitData"/>
        </el-badge>
        </div>
        <div class="TTL-button TTL-btn-option">
        <wcbutton :option="{title:'清空已填模板',type:'del'}" @finish="Delgoods(-1)"/>
        </div>
        <div class="TTL-button TTL-btn-option">
        <wcbutton :option="{title:'新增商品',type:'del'}" @finish="AddGoodsInfo"/>
        </div>
        <div class="TTL-button TTL-btn-option">
        <wcbutton :option="{title:'返回商品管理',type:'del'}" @finish="$parent.JUMPVIEW({name:'EsGoods'})"/>
        </div>
    </div>
    
    <div>
        <div class="TTL-form-submit-box " v-for="(item,index) in goodslist" :key="index">
            <div class="TTL-form-submit-box-title">商品-{{index+1}}</div>
            <div class="TTL-button TTL-btn-option">
            <el-button type="del" v-if="goodslist.length > 1" @click.stop="Delgoods(index)">删除</el-button>
            </div>
            <el-form :inline="false" style="margin-top:20px">
                <el-form-item>
                    <label class="TTL-form-label">商品图<i>*</i></label>
                    <wcuploadmore :option="{type:'select'}" 
                        :value="item.photos" 
                        @finish="(val)=> {
                            var photos=val.url;
                            item.photos=photos;
                            getThumb(item);
                            SaveDataToBrowser();
                        }" 
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">发布类型<i>*</i></label>
                    <wcselect :option="{placeholder:'请选择发布类型',filterable:true,ischange:true,width:'250px'}" 
                        :value="item.type" 
                        :list="saletypelist"
                        @finish="(val)=> {
                            if(val.type=='change') {
                                item.type=val.value;
                                SaveDataToBrowser();
                            }
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">商品名称<i>*</i></label>
                    <wcinput :option="{placeholder:'请输入商品名称',type:'input',clearable:true,ischange:true,isinput:true,iskeydown:true,width:'250px'}" 
                        :value="item.name"
                        @finish="(val)=> {
                            if(val.type=='input' || val.type=='change') {
                                item.name=val.value;
                                SaveDataToBrowser();
                            }
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">售价<i>*</i></label>
                    <wcinput :option="{placeholder:'请输入售价',type:'input',clearable:true,ischange:true,isinput:true,iskeydown:true,width:'250px'}" 
                        :value="item.price"
                        @finish="(val)=> {
                            item.price=val.value;
                            SaveDataToBrowser();
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">原价</label>
                    <wcinput :option="{placeholder:'请输入售价',type:'input',clearable:true,ischange:true,isinput:true,iskeydown:true,width:'250px'}" 
                        :value="item.baseprice"
                        @finish="(val)=> {
                            item.baseprice=val.value;
                            SaveDataToBrowser();
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">库存</label>
                    <wcinput :option="{placeholder:'请输入库存',type:'input',clearable:true,ischange:true,isinput:true,iskeydown:true,width:'250px'}" 
                        :value="item.inventory"
                        @finish="(val)=> {
                            item.inventory=val.value;
                            SaveDataToBrowser();
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">所属分类<i>*</i></label>
                    <wccascader 
                        :option="{placeholder:'请选择商品分类',filterable:true,ischange:true,width:'250px'}" 
                        :value="item.cateid > 0 ? [item.pcateid,item.cateid] : item.pcateid > 0 ? [item.pcateid] : [] " 
                        :list="catelist"
                        @finish="(val)=> {
                            item.pcateid=val.pcateid;
                            item.pname=val.pcatename;
                            item.cateid=val.scateid;
                            item.catename=val.scatename;
                            console.log(val)
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">疫苗情况<i>*</i></label>
                    <wcselect :option="{placeholder:'请选择疫苗情况',filterable:true,ischange:true,width:'250px'}" 
                        :value="item.Fineness" 
                        :list="finenesslist"
                        @finish="(val)=> {
                            if(val.type=='change') {
                                item.Fineness=val.value;
                                SaveDataToBrowser();
                            }
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">交易方式<i>*</i></label>
                    <wcselect :option="{placeholder:'请选择交易方式',filterable:true,ischange:true,width:'250px'}" 
                        :value="item.shippingtype" 
                        :list="shippinglist"
                        @finish="(val)=> {
                            if(val.type=='change') {
                                item.shippingtype=val.value;
                                SaveDataToBrowser();
                            }
                        }"
                    />
                </el-form-item>
                <el-form-item v-if="item.shippingtype==1">
                    <label class="TTL-form-label">运费</label>
                    <wcinput :option="{placeholder:'请输入运费',type:'input',clearable:true,ischange:true,isinput:true,iskeydown:true,width:'250px'}" 
                        :value="item.shippingprice"
                        @finish="(val)=> {
                            item.shippingprice=val.value;
                            SaveDataToBrowser();
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">交易地点<i>*</i></label>
                    <wccitycascader 
                        :option="{placeholder:'请选择交易地点',filterable:true,ischange:true,width:'250px'}" 
                        :value="item.cityinfo" 
                        :list="citylist"
                        @finish="(val)=> {
                            item.cityinfo=val.cityinfo;
                            SaveDataToBrowser();
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">详细地址<i>*</i></label>
                    <wcinput :option="{placeholder:'请输入详细地址',type:'input',clearable:true,ischange:true,isinput:true,iskeydown:true,width:'300px'}" 
                        :value="item.addressname"
                        @finish="(val)=> {
                            if(val.type=='input' || val.type=='change') {
                                item.addressname=val.value;
                                SaveDataToBrowser();
                            }
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">经度</label>
                    <wcinput :option="{placeholder:'请输入地址经度',type:'input',clearable:true,ischange:true,isinput:true,iskeydown:true,width:'250px'}" 
                        :value="item.longitude"
                        @finish="(val)=> {
                            if(val.type=='input' || val.type=='change') {
                                item.longitude=val.value;
                                SaveDataToBrowser();
                            }
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">维度</label>
                    <wcinput :option="{placeholder:'请输入地址维度',type:'input',clearable:true,ischange:true,isinput:true,iskeydown:true,width:'250px'}" 
                        :value="item.latitude"
                        @finish="(val)=> {
                            if(val.type=='input' || val.type=='change') {
                                item.latitude=val.value;
                                SaveDataToBrowser();
                            }
                        }"
                    />
                </el-form-item>
                <el-form-item>
                    <label class="TTL-form-label">商品描述</label>
                    <wcinput :option="{placeholder:'请输入商品描述',type:'input',clearable:true,ischange:true,isinput:true,iskeydown:true,width:'450px'}" 
                        :value="item.note"
                        @finish="(val)=> {
                            if(val.type=='input' || val.type=='change') {
                                item.note=val.value;
                                SaveDataToBrowser();
                            }
                        }"
                    />
                </el-form-item>

                <el-form-item class="top40">
                    <wcbutton 
                        :option="{title:'选择发布人'}" 
                        @finish="$parent.JUMPVIEW({name:'EsMembers',param:{childtype:'selectmember',rollbackindex:index,rollbackobjname:'EsAddGoods'}})"
                    />
                </el-form-item>
                <div v-if="item.memberid > 0">
                     <el-form-item>
                        <label class="TTL-form-label">发布人头像</label>
                        <wcimage :option="{size:'large'}" :value="item.memberthumb" />
                    </el-form-item>
                    <el-form-item>
                        <label class="TTL-form-label">发布人名称</label>
                        <wcinput :option="{type:'input',disable:true,width:'250px'}" :value="item.membername" />
                    </el-form-item>
                    <el-form-item>
                        <label class="TTL-form-label">发布人手机</label>
                        <wcinput :option="{type:'input',disable:true,width:'250px'}" :value="item.phone" />
                    </el-form-item>
                    <el-form-item>
                        <label class="TTL-form-label">发布人类型</label>
                        <wcinput :option="{type:'input',disable:true,width:'250px'}" :value="item.iscompany==1 ? '普通会员' : '企业会员'" />
                    </el-form-item>
                </div>

            </el-form>
        </div>
    </div>
</div>

</template>

<script>
import INTERFACE_MODEL_GOODS from '@/Interface/Es/Goods/Goods';
export default {
    components:{},
    data() {
        return {
            Browser:'addgoods',
            loadingobj:'addgoods',
            limit:5,             //限制添加数据条数
            goodsinfo:{          //商品模板信息           
                name:'',
                spec:[],
                thumb:'',
                photos:[],
                type:1,
                iscompany:1,
                memberid:'',
                pcateid:'',
                pname:'',
                cateid:'',
                catename:'',
                membername:'',
                memberthumb:'',
                phone:'',
                Fineness:'',
                content:[],
                note:'',
                price:'',
                baseprice:'',
                inventory:'',
                cityinfo:[],
                addressname:'',
                longitude:'',
                latitude:'',
                paytype:3,
                shippingtype:'',
                shippingprice:'',
                underline:2
            }, 
            goodslist:[],         //商品信息列表
            typelists:[],
            catelist:[],
            saletypelist:[],
            finenesslist:[],
            underlines:[],
            shippinglist:[],
            citylist:[],
            
            addressinfos: {
                view:false,
                addressname:'',
                longitude:'',
                latitude:'',
                index:'',
            },

        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            this.ParseData();  //解析之前填写的数据
            this.GetMemberTypes(isfresh);
            this.GetCateInfos(isfresh);
            this.GetSalestypeList(isfresh);
            this.GetFinesstypeList(isfresh);
            this.GetUnderLines(isfresh);
            this.GetShippingList(isfresh);
            this.GetCityList(isfresh);
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {  //兄弟组件跳转至当前组件时进行询问操作
                if(data.param.type=='selectmember') {
                    var index=data.param.index;
                    var data=data.param.data;
                    var goodsinfo=this.goodslist[index];
                    goodsinfo.iscompany=data.iscompany;
                    goodsinfo.memberid=data.id;
                    goodsinfo.membername=data.name;
                    goodsinfo.phone=data.phone;
                    goodsinfo.memberthumb=data.thumb;
                }

            }else if(data.reload) {  //浏览器重新刷新时执行的操作
                
            }
        },


        /** 获取地图信息 **/
        GetAddress(item,index) {
            this.addressinfos= {
                view:true,
                addressname:item.addressname,
                longitude:item.longitude,
                latitude:item.latitude,
                index:index
            };
        },


        /** 保存模板信息 **/
        submitData() {
            if(this.goodslist.length==0) {this.$notice({title:'错误提示',message:'请至少填写一个品牌',type:'warning'});return false;}
            var data=[];
            for(var i in this.goodslist) data.push(this.goodslist[i]);
            data=JSON.stringify(data);

            var obj=this.$refs[this.loadingobj];
            this.$loading.openloading(obj);
            INTERFACE_MODEL_GOODS.ADD_GOODS({data:data}).then((res) => {
                this.$loading.closeloading(obj);
                if(res.status > 0) return false;
                this.ResetParam(); //重置数据
                this.$notice({title:'成功提示',message:'添加数据成功',type:'success'});
            });
        },


        //////////////////////////////////////////////////////////////////////
        //////////////////////////////////////////////////////////////////////
        //基础数据操作


        /** 新增模板信息 **/
        AddGoodsInfo() {
            if(this.goodslist.length >= this.limit) {this.$notice({title:'错误提示',message:'新增模板数量不能超过'+this.limit+'个',type:'warning'});return false;}
            var dateinfo={};
            for(var i in this.goodsinfo) dateinfo[i]=this.goodsinfo[i];
            this.goodslist.push(dateinfo);
            this.SaveDataToBrowser();
        },

        
        /** 提取封面图 **/
        getThumb(item) {
            var thumb='';
            var photos=item.photos;
            for(var i in photos) photos[i].is_cover ? thumb=photos[i].thumb : '';
            item.thumb=thumb;
        },


        /** 删除模板信息 **/
        Delgoods(index) {

            //删除单个模板信息时，无需询问，直接删除
            if(index >=0) {
                this.goodslist.splice(index,1);
                this.SaveDataToBrowser();
                return false;
            } 

            //删除全部模板时先询问再操作
            this.$confirm.confirm(
                '您是否确定要删除当前所有模板文件信息 ？',
                '删除提示',
                {confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}
            ).then(()=> {
                this.ResetParam();
            }).catch(()=> {

            });
        },   


        /** 添加商品规格 **/
        addgoodsspecs(goods) {
            goods.spec.push({name:'',value:''});
        },


        /** 数据重置 **/
        ResetParam() {
             this.goodslist=[];
             this.AddGoodsInfo();
        },


        /** 缓存数据到浏览器 **/
        SaveDataToBrowser() {
            this.$LOCALDATA.SetBrowData(this.Browser,this.goodslist);
        },


        /** 从浏览器提取数据解析 **/
        ParseData() {
            this.goodslist=this.$LOCALDATA.GetBrowData(this.Browser);
            if(this.goodslist.length==0) this.AddGoodsInfo();
        },


        /** 获取会员类型信息 **/
        GetMemberTypes(isfresh) {
            this.$method.GET_MEMBER_TYPES(isfresh).then((res) => {this.typelists=res;console.log(res)});
        },


        /** 获取商品类型信息 **/
        GetCateInfos(isfresh) {
            this.$method.GET_CATES_ALL(isfresh).then((res) => {
                var data=res;
                var parent=[];
                var child=[];
                for(var i in data) data[i].pid==0 ? parent.push({value:data[i].id,label:data[i].name,children:[]}) : child.push({value:data[i].id,label:data[i].name,pid:data[i].pid});
                for(var i in parent) {
                    for(var ii in child) {
                        if(parent[i].value==child[ii].pid) parent[i].children.push({value:child[ii].value,label:child[ii].label});
                    }
                }
                this.catelist=parent;
                console.log(parent)
            });
        },


        /** 获取商品类型信息 **/
        GetSalestypeList(isfresh) {
            this.$method.GET_SALES_TYPES(isfresh).then((res) => {this.saletypelist=res;console.log(res)});
        },


        /** 获取商品成色信息 **/
        GetFinesstypeList(isfresh) {
            this.$method.GET_FINENESS(isfresh).then((res) => {this.finenesslist=res;console.log(res)});
        },

        /** 获取商品上下架类型 **/
        GetUnderLines(isfresh) {
            this.$method.GET_GOODS_UNDER_LINE(isfresh).then((res) => {this.underlines=res;console.log(res)});
        },

        /** 获取交易方式 **/
        GetShippingList(isfresh) {
            this.$method.GET_SHIPPING_LIST(isfresh).then((res) => {this.shippinglist=res;console.log(res)});
        },

        /** 获取城市信息列表 **/
        GetCityList(isfresh) {
            this.$method.GET_CITY_LIST(isfresh).then((res) => {this.citylist=res;console.log(res)});
        },


    },
}
</script>
<style scoped>
.TTL-image-box-large {cursor: pointer;width:auto !important;}
.TTL-image-box-large .el-image {width:100px;height:100px;display: inline-block;border-radius: 15px;background-color: #EBEDF0;}
.imagefile {display:inline-flex !important;justify-content: center !important;align-items:center !important;}
::v-deep(.imagefile .el-image__inner) {width:50% !important;height: 50% !important;}

.TTL-image-box-large span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}
.TTL-btn-option {display:inline-block;margin-right:20px;}
::v-deep(.TTL-radio .el-radio__label) {display: inline-flex !important;align-items: center !important;}
.TTL-radio .el-image {width:18px;height: 18px;}
.petTitle {padding:30px 0 20px 0;}
.TTL-photos {display:inline-block;width:100%;font-size:0;}
.TTL-photos-infos {display:inline-block;width:100px;height:100px;margin-right:10px;margin-bottom:10px;background-color:#e6e7ec;border-radius: 15px;overflow:hidden;position:relative;}
.TTL-photos-infos .el-image {width:100%;height:100%;}
.TTL-photos-del {width:25px;height:25px;position: absolute;top:0;right:0;margin-top:5px;margin-right:5px;border-radius: 50%;background-color: rgba(0,0,0,1);display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/close.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.default-photos {background-image:url(@/assets/icon/default-img.png);background-repeat: no-repeat;background-size: 65%;background-position: center;cursor: pointer;}
.TTL-photos-select {width:25px;height:25px;position: absolute;bottom:0;right:0;margin-bottom:5px;margin-right:5px;border-radius: 50%;background-color:#666eeb;display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/right.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.TTL-photos-select-no {width:25px;height:25px;position: absolute;bottom:0;right:0;margin-bottom:5px;margin-right:5px;border-radius: 50%;background-color:rgba(221,221,221,.6);display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/right.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.TTL-form-label i {font-style:normal;color:red;font-size:12px;font-weight: 400;}
.fileup {background-color: #666eeb !important;}
::v-deep(.fileup .el-image__inner) {width:80% !important;height: 80% !important;}
.TTL-member-list {display:inline-block;width:100%;}
.TTL-member-list-info {display:inline-block;width:100%;font-size: 13px;line-height: 30px;margin-left:20px;color:#666666;}
.noaddress {width:auto;}
.TTL-addressname {color:#666666;font-size: 13px;}
.TTL-address-btn {color:#666eeb;font-size:13px;cursor: pointer;}
</style>